import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SplitterComponent } from 'src/app/ui/splitter/splitter.component';
import { OrdersListComponent } from './orders-list/orders-list.component';
import { RqaCreateMapComponent } from 'src/app/map/rqa-map/rqa-map.component';

@Component({
  selector: 'rqa-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss'],
  standalone: true,
  imports: [CommonModule, SplitterComponent]
})
export class OrdersComponent {
  leftSideComponent = OrdersListComponent;
  rightSideComponent = RqaCreateMapComponent;
}
